import { getNoteChromaticIndex } from '../note/note-lib.js'
import type { NoteEvent } from '../progression/event.js'

const pitch = (event: NoteEvent) => getNoteChromaticIndex(event.note) + (event.octave ?? 4) * 12

/**
 * Does `from`'s tie (`C4/q~`) continue into `next`? A tie joins two notes of the SAME pitch. Into a
 * rest, a different pitch, or nothing at all, it means nothing: the note is played and drawn
 * untied. Playback and the renderer both ask this, so a tie that is not heard is not drawn either.
 */
export const continuesTie = (from: NoteEvent, next?: NoteEvent): boolean =>
  Boolean(from.tie && next && !from.rest && !next.rest && pitch(next) === pitch(from))
